import api from "./api";

export const StatusAPI = {
  list: () => api("/statuses"),
};